<p>
  induction-modules-edit works!
</p>
